var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.notes),function(note){return _c('NoteItem',{key:`${note.id}-${_vm.showCategoryTitle ? 'with-category-title' : 'without-category-title'}`,attrs:{"note":note,"renaming":_vm.isRenaming(note.id),"show-category-title":_vm.showCategoryTitle},on:{"note-selected":_vm.onNoteSelected,"start-renaming":_vm.onStartRenaming}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }